import { string, object } from 'yup';

export const schemaChangePassword = object().shape({
  password: string().required('requiredField').min(6, 'minSixCharacters'),
  passwordConfirmation: string()
    .test('passwords-match', 'passwordNotMatch', function(value){
      return this.parent.password === value
    })
});